// extracted by mini-css-extract-plugin
module.exports = {"img":"LandingPage_img__AXDhK","button":"LandingPage_button__HTuq5","title":"LandingPage_title__3Ua1p"};